'use client';

import { c as _c } from "react/compiler-runtime";
import { CallScriptLauncher } from '@components/callScript/CallScriptLauncher';
import { ContactSession } from '@components/contacts/sessions/ContactSession';
import { AppConfig } from '@config';
import { useSoftphoneListener } from '@hooks/useSoftphoneListener';
import { SoftphoneConnectionBehaviorEnum, SoftphoneIntegrationEnum } from '@lib/enums';
import { POPUP_WINDOW_PREFIX } from '@lib/utils';
import { impersonationAtom } from '@states/impersonation/impersonationAtom';
import { useJotaiValue } from '@states/jotai/hooks';
import { softphoneAtom } from '@states/softphone/softphoneAtom';
import type { FC, ReactNode } from 'react';
type Props = Readonly<{
  children: ReactNode;
}>;
export const SoftphoneSession: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  useSoftphoneListener();
  const {
    azureAdId: impersonatedAzureAdId
  } = useJotaiValue(impersonationAtom);
  const {
    connectionBehavior
  } = useJotaiValue(softphoneAtom);
  const isSoftphoneEnabled = impersonatedAzureAdId == null && (window?.name == null || !window.name.startsWith(POPUP_WINDOW_PREFIX)) && AppConfig.softphoneIntegration.client === SoftphoneIntegrationEnum.Contacts && connectionBehavior === SoftphoneConnectionBehaviorEnum.AutoConnect;
  let t1;
  if ($[0] !== children || $[1] !== isSoftphoneEnabled) {
    t1 = isSoftphoneEnabled ? <ContactSession>{children}</ContactSession> : children;
    $[0] = children;
    $[1] = isSoftphoneEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CallScriptLauncher />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};